/*
* fn [function] 需要防抖的函数
* delay [number] 毫秒，防抖期限值
*/
export function _debounce(fn, delay) {

	var delay = delay || 200;
	var timer;
	return function () {
		var th = this;
		var args = arguments;
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(function () {
			timer = null;
			fn.apply(th, args);
		}, delay);
	};
}
/*
* fn [function] 需要节流的函数
* interval [number] 毫秒
*/
export function _throttle(fn, interval) {
	var last;
	var timer;
	var interval = interval || 200;
	return function () {
		var th = this;
		var args = arguments;
		var now = +new Date();
		if (last && now - last < interval) {
			clearTimeout(timer);
			timer = setTimeout(function () {
				last = now;
				fn.apply(th, args);
			}, interval);
		} else {
			last = now;
			fn.apply(th, args);
		}
	}
}


/**
* 判断参数类型
* @param {*} val [参数]
*/
export const isType = (val) => {
	return Object.prototype.toString.call(val).split(' ')[1].slice(0, -1);
}

// 计算年日期

export let FORMAT_YEAR = () => {
	let yearArr = [];
	let currentYear = new Date().getFullYear();
	let startYear = 2020;
	let interval = currentYear - startYear;
	for (let i = 0; i < interval + 1; i++) {
		if (i == 0) {
			yearArr.push(startYear);
		} else {
			yearArr.push(yearArr[i - 1] + 1);
		}
	}
	return yearArr
}

